import React, { useState } from "react";
import ComponentCustomModal from "../../../components/common/customModal/ComponentCustomModal";
import { useTranslation } from "react-i18next";
import Loader from "../../../components/common/Loader";
import { Form, Formik } from "formik";
import { FtextField } from "../../../components/common/FtextField";
import useDataInputOption from "../../../hooks/useDataInputOption";
import { updateNetworkDeviceOutput } from "../../../features/oltApi";
import { useDispatch, useSelector } from "react-redux";

const DeviceOutputDialog = ({ show, setShow, parent }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  //---> Get network device outputs form redux store
  const outputs = useSelector((state) => state.network?.outputs);
  const output = outputs.find((item) => item.id === parent.output);

  //---> Local State
  const [isLoading, setIsLoading] = useState(false);

  const inputOptions = [
    {
      name: "color",
      as: "select",
      type: "select",
      id: "color",
      isVisible: true,
      disabled: false,
      validation: false,
      label: t("colorCode"),
      firstOptions: t("colorCode"),
      textAccessor: "name",
      valueAccessor: "value",
      options: [
        { name: t("blue"), value: "blue" },
        { name: t("red"), value: "red" },
        { name: t("purple"), value: "purple" },
        { name: t("black"), value: "black" },
        { name: t("yellow"), value: "yellow" },
        { name: t("green"), value: "green" },
        { name: t("pink"), value: "pink" },
        { name: t("white"), value: "white" },
        { name: t("gray"), value: "gray" },
        { name: t("orange"), value: "orange" },
        { name: t("brown"), value: "brown" },
      ],
    },
    {
      name: "cableLength",
      type: "text",
      id: "cableLength",
      isVisible: true,
      disabled: false,
      validation: false,
      label: t("cableLength"),
    },
    {
      name: "description",
      as: "textarea",
      type: "textarea",
      id: "description",
      isVisible: true,
      disabled: false,
      validation: false,
      label: t("description"),
    },
  ];

  const handleNetworkDeviceOutputFormSubmission = (formValues) => {
    console.log(formValues);

    updateNetworkDeviceOutput(
      dispatch,
      parent.output,
      formValues,
      setIsLoading,
      setShow,
    );
  };

  return (
    <>
      <ComponentCustomModal
        {...{
          show,
          setShow,
          header: t("updateDeviceOutput"),
          footer: (
            <div className="displayGrid1 float-end">
              <button
                type="button"
                className="btn btn-secondary border-0"
                disabled={isLoading}
                onClick={() => setShow(false)}
              >
                {t("cancel")}
              </button>

              <button
                type="submit"
                form="deviceOutputForm"
                className="btn btn-success border-0"
                disabled={isLoading}
              >
                {isLoading ? <Loader /> : t("save")}
              </button>
            </div>
          ),
        }}
      >
        <Formik
          initialValues={{
            color: output?.color || "",
            cableLength: output?.cableLength || "",
            description: output?.description || "",
          }}
          onSubmit={(values) => {
            handleNetworkDeviceOutputFormSubmission(values);
          }}
          enableReinitialize
        >
          {() => (
            <Form id="deviceOutputForm">
              <div className="displayGrid">
                {inputOptions?.map(
                  (item) =>
                    item?.isVisible && <FtextField key={item.name} {...item} />,
                )}
              </div>
            </Form>
          )}
        </Formik>
      </ComponentCustomModal>
    </>
  );
};

export default DeviceOutputDialog;
